import eventBus from "@sd-utility/eventbus";
import { getTabs } from "client/api/amplience";
import { FACET_UPDATE_EVENT } from "client/utils/consts";
import React, { createContext, useContext, useEffect, useRef, useState } from "react";
import { AmpTabs } from "types/amplience";
import useGlobalConfig from "./GlobalConfig";

export interface TabConfig {
  tabs?: AmpTabs;
  defaultTab?: number;
}

const TabConfigContext = createContext<TabConfig>({});
TabConfigContext.displayName = "TabConfigContext";

export const TabConfigProvider: React.FC<React.PropsWithChildren<{ value: TabConfig; initPath: string }>> = ({
  value: initValue,
  initPath,
  ...props
}) => {
  const initRender = useRef(true);
  const [path, setPath] = useState(initPath);
  const [value, setValue] = useState(initValue);
  const { brand } = useGlobalConfig();

  useEffect(() => {
    const subscription = eventBus.subscribe(FACET_UPDATE_EVENT, (e) => {
      const url = new URL(e.path, location.origin);
      setPath(url.pathname);
    });

    return subscription.unsubscribe;
  }, []);

  useEffect(() => {
    const popStateListener = () => setPath(location.pathname);
    window.addEventListener("popstate", popStateListener);
    return () => window.removeEventListener("popstate", popStateListener);
  }, []);

  useEffect(() => {
    if (initRender.current) {
      initRender.current = false;
      return;
    }

    (async () => {
      const res = await getTabs(brand, path);
      setValue((s) => ({ ...s, tabs: res }));
    })();
  }, [brand, path]);

  return <TabConfigContext.Provider {...props} value={value} />;
};

const useTabConfig = () => useContext(TabConfigContext);
export default useTabConfig;
